<template>
  <div class="login">
    <div class="login-bg">
    </div>
    <div class="login-container">
      <div class="login-area">
        <h2>
          {{$store.getters.sysConfigs['TITLE']}}
        </h2>
        <h1>
          系统登录
        </h1>
        <div class="padding-top-20"></div>
        <div class="login-box">
          <Tabs type="card" class="tab-square">
            <TabPane label="账密登录">
              <Form ref="loginForm" :model="loginModel" :rules="ruleValidate" label-position="top">
                <FormItem prop="loginName">
                  <Input v-model="loginModel.loginName"
                    @keyup.enter.native="login"
                    size="large"
                    placeholder="输入用户名">
                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model="loginModel.password"
                    @keyup.enter.native="login"
                    size="large"
                    type="password" placeholder="输入密码">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="captcha">
                  <Input v-model="loginModel.captcha"
                    @keyup.enter.native="login"
                    placeholder="图形验证码" style="width:140px" />
                  <img :src="captchaImg" v-if="captchaImg" style="cursor:pointer;vertical-align:middle;margin-left:5px" @click="getCaptcha" />
                </FormItem>
                <div class="login-btns">
                  <Button type="primary" size="large" long style="width: 200px" @click="login" :disabled="loading">登录</Button>
                  <Button type="default" size="large" to="/forget-password">忘记密码</Button>
                </div>
                <Button type="default" size="large" @click="gotoRegister" v-if="$store.getters.sysConfigs['ENABLE_REGISTER']" long style="margin-top: 10px">注册新用户</Button>
              </Form>
            </TabPane>
            <TabPane label="CA登录">
              <Alert show-icon>
                <!-- 插入CA证书设备 -->
                <Icon type="md-key" slot="icon"></Icon>
                <template slot="desc">
                  请插入指定的CA证书设备后点击下方按钮(请使用IE10+,Edge,Chrome,360等浏览器)
                  <a href="./static/TopESA/CA驱动&插件.zip">CA插件下载</a>
                </template>
              </Alert>
              <p class="text-center">
                <CertSelectModal
                  :show="showCertSelectModal"
                  :dataSigning="loginData"
                  @cert-verified="certLoginSigned"
                  @close-modal="showCertSelectModal=false" />
                <Button type="warning" size="large" long style="width:200px;height:60px;margin:20px auto" @click="loginWithCert" :disabled="loading">CA登录</Button>
              </p>
            </TabPane>
            <TabPane label="短信登录" v-if="$store.getters.sysConfigs['ENABLE_SMS_LOGIN']">
              <Form ref="loginMobileForm" :model="loginMobileModel" :rules="ruleMobileValidate" label-position="top">
                <FormItem prop="mobile">
                  <Input v-model="loginMobileModel.mobile"
                    @keyup.enter.native="login"
                    size="large"
                    placeholder="手机号">
                    <Icon type="ios-phone-portrait" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="sms">
                  <Input v-model="loginMobileModel.sms"
                    @keyup.enter.native="login"
                    size="large"
                    placeholder="输入验证码">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    <Button slot="append" @click="sendSms" :disabled="smsCoolingDown>0">{{smsCoolingDown>0?smsCoolingDown+'秒后可重新获取':'获取验证码'}}</Button>
                  </Input>
                </FormItem>
                <!-- <FormItem prop="vericode">
                  <Input v-model="loginModel.vericode"
                    @keyup.enter.native="login"
                    placeholder="图形验证码" style="width:140px" />
                  <img :src="captchaImg" v-if="captchaImg" style="cursor:pointer;vertical-align:middle;margin-left:5px" @click="getCaptcha" />
                </FormItem> -->
                <div class="login-btns">
                  <Button type="warning" size="large" long @click="loginSms" :disabled="loading">登录</Button>
                </div>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div class="verify" v-if="$store.getters.sysConfigs['SHOW_PUBLISHED_GUARANTORS']"><router-link to="/published" style="color:#fff;">保证人名单公示<Icon type="ios-arrow-round-forward" /></router-link></div>
        <div class="verify"><router-link to="/verify" style="color:#fff;">保函验真<Icon type="ios-arrow-round-forward" /></router-link></div>
      </div>
    </div>
    <Footer class="footer" :style="{padding: '5px 0px', color: '#777', fontSize: '12px'}" />
    <NewUserModal :show="showNewUserModal" @on-close="showNewUserModal=false" />
  </div>
</template>

<script>
import Api from './../api/Api'
import CertSelectModal from './../components/CertSelectModal'
import NewUserModal from './Users/AddInModal'
import Footer from '@/components/Footer'
export default {
  name: 'login',
  components: {
    CertSelectModal,
    NewUserModal,
    Footer
  },
  data () {
    return {
      loginModel: {
        loginName: '',
        password: '',
        passwordMd5: '',
        captcha: ''
      },
      loginMobileModel: {
        mobile: '',
        sms: ''
      },
      ruleValidate: {
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ]
      },
      ruleMobileValidate: {
        mobile: [
          { required: true, message: '请填写手机号码', trigger: 'blur' }
        ],
        sms: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ]
      },
      captchaImg: '',
      loading: false,
      accountApi: null,
      smsCoolingDown: 0,
      cdTask: null,
      showCertSelectModal: false,
      loginData: null,
      showNewUserModal: false
    }
  },
  mounted () {
    let backImgUrl = this.$store.getters.sysConfigs['WELCOME_BACKGROUND_IMAGE_URL'] || 'bg_01.jpg'
    if (backImgUrl && backImgUrl.toLowerCase().indexOf('http') === 0) {
      backImgUrl = `url(${backImgUrl})`
    } else {
      backImgUrl = `url('/static/'${backImgUrl})`
    }
    document.querySelector('.login').style.backgroundImage = backImgUrl
    this.getCaptcha()
  },
  methods: {
    async getCaptcha () {
      await Api.Auth(this).getCaptcha().then((img) => {
        this.captchaImg = img
      })
    },
    async sendSms () {
      clearInterval(this.cdTask)
      if (!this.loginMobileModel.mobile) {
        this.$Notice.error({
          title: '请填写手机号'
        })
        return false
      }
      await Api.Auth(this).sendSmsCode(this.loginMobileModel.mobile).then(() => {
        this.$Message.success('短信已发送')
        this.smsCoolingDown = 60
        this.cdTask = setInterval(() => {
          if (this.smsCoolingDown > 0) {
            this.smsCoolingDown -= 1
          } else {
            clearInterval(this.cdTask)
          }
        }, 1000)
      }).catch(err => {
        this.$Notice.error({
          title: '发送验证码失败',
          desc: err.message
        })
      })
    },
    async login () {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.loginModel.passwordMd5 = this.$md5(this.loginModel.password)
          await Api.Auth(this).login(this.loginModel)
          .then((payload) => {
            // console.log(payload)
            window.localStorage.setItem('token', payload)
            this.$Message.success('登陆成功!')
            this.loading = false
            this.$Spin.hide()
            Api.Auth(this).getMyDetail().then((data) => {
              this.$store.dispatch('setUserInfo', data)
              window.localStorage.setItem('userInfo', JSON.stringify(data))
            })
            this.$router.push({path: '/dashboard'})
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '登陆失败!',
              desc: err.message
            })
            this.getCaptcha()
            this.loginModel.captcha = null
          })
        }
      })
    },
    async loginSms () {
      this.$refs.loginMobileForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Auth(this).loginViaSms(this.loginMobileModel)
          .then((payload) => {
            // console.log(payload)
            window.localStorage.setItem('token', payload)
            this.$Message.success('登陆成功!')
            this.loading = false
            this.$Spin.hide()
            Api.Auth(this).getMyDetail().then((data) => {
              this.$store.dispatch('setUserInfo', data)
              window.localStorage.setItem('userInfo', JSON.stringify(data))
            })
            this.$router.push({path: '/dashboard'})
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '登陆失败!',
              desc: err.message
            })
          })
        }
      })
    },
    loginWithCert () {
      this.loginData = Math.round(Math.random() * 100000).toString()
      this.showCertSelectModal = true
    },
    async certLoginSigned (certSigned) {
      console.log(certSigned)
      this.$Spin.show()
      await Api.Auth(this).loginViaCert({
        rand: this.loginData,
        certSn: certSigned.certSn,
        sign: certSigned.sign
      }).then((payload) => {
        // console.log(payload)
        window.localStorage.setItem('token', payload)
        this.$Message.success('登陆成功!')
        this.loading = false
        this.$Spin.hide()
        Api.Auth(this).getMyDetail().then((data) => {
          this.$store.dispatch('setUserInfo', data)
          window.localStorage.setItem('userInfo', JSON.stringify(data))
        })
        this.$router.push({path: '/dashboard'})
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '登陆失败!',
          desc: err.message
        })
      })
    },
    gotoRegister () {
      let mode = this.$route.query.mode || 'henan'
      if (mode === 'henan') {
        this.$router.push('/register?mode=' + mode)
      } else {
        this.showNewUserModal = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  display: flex;
  flex-direction: row;
  height: 100vh;
  background-color: #f2f2f2;
  overflow: hidden;
  color: #efefef;
  background-image: url('./../assets/login_bg_1.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .login-container {
    background-color: rgba(#334458,0.7);
    padding: 16px;
    flex-basis: 38.2%;
    min-width: 352px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .login-area {
      h2 {
        color: lighten(@primaryColor, 20%);
      }
      h1 {
        color: lighten(@secondaryColor, 20%);
      }
    }
    .login-box {
      width: 330px;
      padding: 15px;
      background: #8aa3bd;
      border: 1px solid #999;
      .login-btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    .ivu-form-item {
      color: #ccc !important;
    }
  }
  .login-bg {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // background-image: url('./../assets/login_bg_1.jpg');
    // background-repeat: no-repeat;
    // background-size: cover;
  }
  .verify {
    width: 330px;
    padding: 15px 0;
    text-align: right;
  }
  .footer {
    position: absolute;
    bottom: 5px;
    left: 5px;
  }
}
</style>
